import { Bounds } from '@ardoq/graph';
import { clamp } from 'lodash';
import { interp } from 'tabview/visualizations/misc/math';
import { rectHeight } from 'tabview/visualizations/misc/geometry';
import {
  AQBLOCKS_SCROLLBAR_BARFILL,
  AQBLOCKS_SCROLLBAR_GUTTERFILL,
} from '../consts';
import { RenderParameters } from './types';

export const renderScrollbars = (world: Bounds, params: RenderParameters) => {
  const { viewport, window } = params.projection;
  const margin = 2;
  const size = 4;
  const gutterFill = AQBLOCKS_SCROLLBAR_GUTTERFILL;
  const barFill = AQBLOCKS_SCROLLBAR_BARFILL;

  if (window[0] > world[0] || window[2] < world[2]) {
    const bar: Bounds = [
      viewport[0] + margin,
      viewport[3] - margin - size,
      viewport[2] - margin - size,
      viewport[3] - margin,
    ];
    const left = clamp(
      interp((window[0] - world[0]) / (world[2] - world[0]), bar[0], bar[2]),
      bar[0],
      bar[2]
    );
    const right = clamp(
      interp((window[2] - world[0]) / (world[2] - world[0]), bar[0], bar[2]),
      bar[0],
      bar[2]
    );

    params.ctx.beginPath();
    params.ctx.roundRect(
      bar[0],
      bar[1],
      bar[2] - bar[0],
      rectHeight(bar),
      size / 2
    );
    params.ctx.fillStyle = gutterFill;
    params.ctx.fill();

    params.ctx.beginPath();
    params.ctx.fillStyle = barFill;
    params.ctx.roundRect(left, bar[1], right - left, rectHeight(bar), size / 2);
    params.ctx.fill();
  }

  if (window[1] > world[1] || window[3] < world[3]) {
    const bar: Bounds = [
      viewport[2] - margin - size,
      viewport[1] + margin,
      viewport[2] - margin,
      viewport[3] - margin - size,
    ];
    const top = clamp(
      interp((window[1] - world[1]) / (world[3] - world[1]), bar[1], bar[3]),
      bar[1],
      bar[3]
    );
    const bottom = clamp(
      interp((window[3] - world[1]) / (world[3] - world[1]), bar[1], bar[3]),
      bar[1],
      bar[3]
    );

    params.ctx.beginPath();
    params.ctx.roundRect(
      bar[0],
      bar[1],
      bar[2] - bar[0],
      rectHeight(bar),
      size / 2
    );
    params.ctx.fillStyle = gutterFill;
    params.ctx.fill();

    params.ctx.beginPath();
    params.ctx.fillStyle = barFill;
    params.ctx.roundRect(bar[0], top, bar[2] - bar[0], bottom - top, size / 2);
    params.ctx.fill();
  }
};
